module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 14.833d0556.png";